import { Button, Flex, Text, useBreakpointValue } from "@chakra-ui/react"
import React from "react"
import { COLORS } from "../../../constants/constants"
import { AddToTripIcon } from "../../../helpers/svgComponent"

const AddToTripBtn = ({
  handleAddToTrip,
  isLoading = false,
  designatedClass,
  disabled = false,
}) => {
  const iconSize = useBreakpointValue({ base: "16px", xl: "20px" })

  return (
    <Flex>
      <Button
        bg={disabled || isLoading ? COLORS.grey100 : COLORS.white}
        borderRadius={11}
        p={{ base: 1, xl: 2 }}
        columnGap={{ base: 1, xl: 2 }}
        onClick={(e) => handleAddToTrip(e, designatedClass)}
        isDisabled={disabled || isLoading}
      >
        <AddToTripIcon iconSize={iconSize} fill={COLORS.red} />
        <Text
          color={COLORS.red}
          fontSize={{ base: 11, xl: 12 }}
          fontWeight={600}
          lineHeight={"16px"}
        >
          Add to trip
        </Text>
      </Button>
    </Flex>
  )
}

export default AddToTripBtn
